import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import NodePage from './pages/NodePage';
import ReferralsPage from './pages/ReferralsPage';
import InvitationPage from './pages/InvitationPage';
import WhitepaperPage from './pages/WhitepaperPage';
import TeamLeadersPage from './pages/TeamLeadersPage';
import HeaderWithWallet from './components/HeaderWithWallet';
import Footer from './components/Footer';
import { WalletProvider } from './context/WalletContext';
import PortfolioPage from './components/PortfolioPage';
import OrderDetailsPage from './components/OrderDetailsPage';
import AssetDetailsPage from './components/AssetDetailsPage';
import DeviceManagementPage from './pages/DeviceManagementPage';
import NotificationSystem from './components/NotificationSystem';
// Import Dashboard pages
import Dashboard from './pages/Dashboard/Dashboard';
// Import CSS files
import './styles/variables-css.css';
import './styles/globals-css.css';
import './styles/animations-css.css';
import './styles/components-css.css';
import './styles/node-application.css';
import './styles/node-stats.css';
import './styles/node-governance.css';
import './styles/node-leaderboard.css';
import './styles/node-calculator.css';
import './styles/node-page.css';
import './styles/wallet-connector.css';
import './styles/purchase-modal.css';
import './styles/header-with-wallet.css';
import './styles/node-management-modals.css';
import './styles/invitation-page.css';
import './styles/portfolio.css';
import './styles/order-details.css';
import './styles/asset-details.css';
import './styles/whitepaper-page.css';
import './styles/team-leaders-page.css';
// Import compatibility fix CSS files
import './styles/css-compatibility-fixes.css';
import './styles/modal-compatibility-fixes.css';
// Import z-index fix CSS file (load this LAST to override other styles)
import './styles/modal-z-index-fix.css';

// Backdrop polyfill function
const applyBackdropFallbacks = () => {
  // Simplified function, avoiding complex detection logic
  try {
    console.log("Applying backdrop fallbacks");
    // Add fallback background color for elements using backdrop-filter
    const header = document.querySelector('header');
    if (header) {
      header.style.backgroundColor = 'rgba(7, 11, 21, 0.95)';
    }
    
    const glassElements = document.querySelectorAll('.glass-card, .feature-card, .package-card, .product-card, .faq-item, .node-tier-card, .node-application-form, .proposal-card, .stat-card, .benefit-card, .calculator-inputs, .calculator-results, .leaderboard-card, .invitation-card, .modal-container, .phase-card, .revenue-card, .testimonial-card, .stream-item, .strategy-step');
    glassElements.forEach(el => {
      el.style.backgroundColor = 'rgba(15, 23, 42, 0.9)';
    });
    
    const footer = document.querySelector('footer');
    if (footer) {
      footer.style.backgroundColor = 'rgba(7, 11, 21, 0.95)';
    }
    
    const ctaSection = document.querySelector('.cta-section');
    if (ctaSection) {
      ctaSection.style.backgroundColor = 'rgba(7, 11, 21, 0.85)';
    }
  } catch (error) {
    console.error("Error applying backdrop fallbacks:", error);
  }
};

// Function to add modal-open class to body when modal is open
const setUpModalBodyClass = () => {
  // Create a MutationObserver to detect when modals are added to the DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        // Check if a modal was added
        const modalOverlay = document.querySelector('.modal-overlay, .wallet-modal-overlay');
        if (modalOverlay) {
          document.body.classList.add('modal-open');
        }
      } else if (mutation.removedNodes.length > 0) {
        // If no modals exist, remove the modal-open class
        const modalOverlay = document.querySelector('.modal-overlay, .wallet-modal-overlay');
        if (!modalOverlay) {
          document.body.classList.remove('modal-open');
        }
      }
    });
  });

  // Start observing the document body for added/removed nodes
  observer.observe(document.body, { 
    childList: true,
    subtree: true 
  });
};

// 修复WhitepaperPage和TeamLeadersPage显示问题
const fixSpecialPages = () => {
  try {
    // 获取当前路径
    const currentPath = window.location.pathname;
    
    // 只针对特定页面应用修复
    if (currentPath === '/whitepaper' || currentPath === '/team-leaders') {
      console.log(`正在修复 ${currentPath} 页面显示问题`);
      
      // 延迟一点执行，确保DOM已经渲染
      setTimeout(() => {
        // 根据路径选择不同页面
        const pageElement = currentPath === '/whitepaper' 
          ? document.querySelector('.whitepaper-page') 
          : document.querySelector('.team-leaders-page');
        
        // 如果找到了目标元素，应用样式修复
        if (pageElement) {
          // 设置页面基本样式确保可见
          pageElement.style.display = 'block';
          pageElement.style.visibility = 'visible';
          pageElement.style.opacity = '1';
          pageElement.style.position = 'relative';
          pageElement.style.zIndex = '5';
          
          // 修复页面内的所有section
          const sections = pageElement.querySelectorAll('section');
          sections.forEach(section => {
            section.style.display = 'block';
            section.style.visibility = 'visible';
            section.style.opacity = '1';
            section.style.position = 'relative';
            section.style.zIndex = '1';
          });
          
          // 修复容器样式
          const containers = pageElement.querySelectorAll('.container');
          containers.forEach(container => {
            container.style.display = 'block';
            container.style.maxWidth = '1200px';
            container.style.marginLeft = 'auto';
            container.style.marginRight = 'auto';
            container.style.padding = '0 20px';
          });
          
          // 修复Hero区域
          const heroSection = pageElement.querySelector('.hero-section');
          if (heroSection) {
            heroSection.style.display = 'block';
            heroSection.style.visibility = 'visible';
            heroSection.style.paddingTop = '8rem';
            heroSection.style.zIndex = '1';
          }
          
          // 修复FAQ项目，确保点击时可正常显示
          const faqItems = pageElement.querySelectorAll('.faq-item');
          faqItems.forEach(item => {
            const question = item.querySelector('.faq-question');
            if (question) {
              question.addEventListener('click', () => {
                item.classList.toggle('active');
              });
            }
          });
          
          console.log(`${currentPath} 页面修复成功应用`);
        } else {
          console.warn(`未找到 ${currentPath} 页面元素`);
        }
      }, 100);
    }
  } catch (error) {
    console.error("应用页面修复时出错:", error);
  }
};

// Layout component to conditionally render header and footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isDashboardRoute = location.pathname.startsWith('/dashboard');
  
  // Dashboard routes don't need header and footer
  if (isDashboardRoute) {
    return (
      <main className="dashboard-main-content">
        {children}
      </main>
    );
  }
  
  // Non-dashboard routes use standard layout
  return (
    <div className="standard-layout">
      <HeaderWithWallet />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    // Add page loaded marker for debugging
    document.body.classList.add('page-loaded');
    
    // Apply backdrop-filter compatibility handling
    applyBackdropFallbacks();
    
    // Set up body class for modals
    setUpModalBodyClass();
    
    // 应用特殊页面修复
    fixSpecialPages();
    
    // Add debug logs to help troubleshoot issues
    console.log("App component mounted");
    
    // Initialize staking tier selections on page load
    const handleStakingTierSelection = () => {
      const stakingTiers = document.querySelectorAll('.staking-tier');
      
      stakingTiers.forEach(tier => {
        tier.addEventListener('click', () => {
          // Find parent card
          const parent = tier.closest('.product-body');
          // Remove active class from all tiers in this card
          parent.querySelectorAll('.staking-tier').forEach(t => {
            t.classList.remove('active');
          });
          // Add active class to clicked tier
          tier.classList.add('active');
        });
      });
    };
    
    // Initialize FAQ toggles
    const initFAQs = () => {
      const faqItems = document.querySelectorAll('.faq-item');
      
      faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        
        question.addEventListener('click', () => {
          // Toggle the current item
          item.classList.toggle('active');
        });
      });
    };
    
    // Initialize chart animations
    const initChartAnimations = () => {
      // Initialize chart animations when they come into view
      const animateCharts = () => {
        const charts = document.querySelectorAll('.chart-bars');
        
        charts.forEach(chart => {
          const chartRect = chart.getBoundingClientRect();
          const isVisible = chartRect.top < window.innerHeight && chartRect.bottom >= 0;
          
          if (isVisible) {
            const bars = chart.querySelectorAll('.chart-bar .bar-fill');
            bars.forEach((bar, i) => {
              setTimeout(() => {
                bar.style.opacity = '1';
                // Get height from style attribute
                const height = bar.getAttribute('style')?.match(/height:\s*(\d+)%/)?.[1];
                if (height) {
                  bar.style.height = `${height}%`;
                }
              }, i * 100);
            });
          }
        });
      };
      
      // Run on scroll
      window.addEventListener('scroll', animateCharts);
      // Run once on load
      setTimeout(animateCharts, 500);
    };
    
    // Run initializations after a short delay to ensure DOM is ready
    setTimeout(() => {
      handleStakingTierSelection();
      initFAQs();
      initChartAnimations();
      // 重新应用特殊页面修复
      fixSpecialPages();
    }, 1000);
    
    // 监听路由变化，在导航时重新应用页面修复
    const handleRouteChange = () => {
      console.log("路由已变更，重新应用页面修复");
      setTimeout(fixSpecialPages, 100);
    };
    
    window.addEventListener('popstate', handleRouteChange);
    
    // Cleanup function
    return () => {
      // Remove any event listeners or observers if needed
      window.removeEventListener('scroll', initChartAnimations);
      window.removeEventListener('popstate', handleRouteChange);
      document.body.classList.remove('modal-open');
      document.body.classList.remove('page-loaded');
    };
  }, []);
  
  return (
    <WalletProvider>
      <Router>
        {/* App wrapper to ensure correct flex layout and footer positioning */}
        <div className="app-wrapper">
          {/* Floating Elements */}
          <div className="floating-elements">
            <div className="floating-element element-1"></div>
            <div className="floating-element element-2"></div>
            <div className="floating-element element-3"></div>
          </div>
          
          {/* Particles */}
          <div className="particles">
            {[...Array(10)].map((_, index) => (
              <div key={index} className="particle"></div>
            ))}
          </div>
          
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/whitepaper" element={<WhitepaperPage />} />
              <Route path="/team-leaders" element={<TeamLeadersPage />} />
              <Route path="/node" element={<NodePage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/orders/:orderId" element={<OrderDetailsPage />} />
              <Route path="/assets/:assetId" element={<AssetDetailsPage />} />
              <Route path="/device/order/:orderId" element={<DeviceManagementPage />} /> 
              <Route path="/referrals" element={<ReferralsPage />} />
              
              {/* Invitation routes */}
              <Route path="/join" element={<InvitationPage />} />
              <Route path="/invite" element={<InvitationPage />} />
              <Route path="/invitation" element={<InvitationPage />} />
              
              {/* Dashboard Routes */}
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard/*" element={<Dashboard />} />
              
              {/* Redirect Routes */}
              <Route path="/node-management" element={<Navigate to="/dashboard/nodes" replace />} />
              <Route path="/team-network" element={<Navigate to="/dashboard/network" replace />} />
            </Routes>
          </Layout>
          
          {/* Global notification system */}
          <NotificationSystem />
        </div>
      </Router>
    </WalletProvider>
  );
}

export default App;
